import { defineMessage } from 'services/localization';

export const messages = {
    anyExistingContactDropdownText: defineMessage('any_existing_customer'),
    contactsExactValuesDropdownText: defineMessage('any_customer_that_matches'),
    contactsNotExactValuesDropdownText: defineMessage('any_customer_except_for'),
    allowToCreateNewCustomers: defineMessage('allow_to_create_new_customers'),
};
